  window.setTimeout(function(){
//         alert('時間切れです');
    }, 5000);


window.onload = function() {

}
